import React from "react";

export default function Pagesstructure({ title, description, content }) {
  return (
    <div className="page-structure-container">
      <div className="page-structure-header">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="page-structure-content">{content}</div>
    </div>
  );
}
